import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import packageJSON from '../../../../package.json';

const Footer = () => {
  const [t] = useTranslation();

  return (
    <footer className="main-footer">
      <strong>
        <span>Bản quyền thuộc </span>
        <a href="" target="_blank" rel="noopener noreferrer">
           "Quỹ Đầu tư phát triển thành phố Đà Nẵng"
        </a>
      </strong>
      <div className="float-right d-none d-sm-inline-block">
        <b>{t<string>('footer.version')}</b>
        <span>&nbsp;{packageJSON.version}</span>
      </div>
    </footer>
  );
};

export default Footer;
